import React, { useContext, useEffect, useRef, useState } from "react";
import Input from "components/Elements/Input";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { getAgents } from "../../services/clients";
import {
  getMediaItem,
  updateMediaItem,
  deleteMediaItem,
} from "../../services/media";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";

DataTable.use(DT);
const EditMediaModal = NiceModal.create(({ public_id, title = "Media" }) => {
  const [savingMedia, setSavingMedia] = useState(false);
  const [mediaItem, setMediaItem] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);
  const formRef = useRef(null);
  const mediaItemRef = useRef(null);
  const modal = useModal();

  useEffect(() => {
    getMediaItem(public_id).then((item) => {
      console.log("!!! MEDIA ITEM: ", item);
      mediaItemRef.current = JSON.stringify(item);
      if (item?.additional_data) {
        try {
          const d = JSON.parse(item.additional_data);
          setAdditionalData(d);
        } catch (e) {
          console.error("!!! ERROR PARSING JSON: ", e);
        }
      }
      setMediaItem(item);
    });
  }, [public_id]);

  const hide = (e) => {
    modal.remove();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.search("additionalData") > -1) {
      const newName = name.split(".").pop();
      console.log("!!! NAME: ", newName);
      if (newName === "tags") {
        const tags = value.split(",");
        setAdditionalData({ ...additionalData, [newName]: tags });
      } else {
        setAdditionalData({ ...additionalData, [newName]: value });
      }

      setMediaItem({
        ...mediaItem,
        additional_data: JSON.stringify(additionalData),
      });
    } else {
      setMediaItem({ ...mediaItem, [name]: value });
    }
    console.log("CHANGE: ", name, value);
  };

  const save = async (e) => {
    setSavingMedia(true);
    const response = await updateMediaItem(mediaItem);
    console.log("!!! SAVE RESPONSE: ", response);
    const updatedMediaItem = response.success ? response.media : null;
    modal.resolve(updatedMediaItem);
    Swal.fire({
      title: "Success",
      text: "Media item updated successfully",
      icon: "success",
      button: "OK",
      confirmButtonText: "OK",
    }).then((result) => {
      setSavingMedia(false);
      modal.remove();
    });
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">Edit {mediaItem?.name}</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form ref={formRef}>
                  <label>ID</label>
                  <Input
                    label="ID"
                    type="text"
                    placeholder="ID"
                    name="id"
                    value={mediaItem?.public_id ?? ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label>Name</label>
                  <Input
                    label="Name"
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={mediaItem?.name ?? ""}
                    onChange={handleChange}
                  />
                  <label>Short Title</label>
                  <Input
                    label="Short Title"
                    type="text"
                    placeholder="Short Title"
                    name="short_title"
                    value={mediaItem?.short_title ?? ""}
                    onChange={handleChange}
                  />
                  <label>Category</label>
                  <Input
                    label="Category"
                    type="text"
                    placeholder="Category"
                    name="additionalData.category"
                    value={additionalData?.category ?? ""}
                    onChange={handleChange}
                  />
                  <label>Tags</label>
                  <Input
                    label="Tags"
                    type="textarea"
                    placeholder="Tags"
                    name="additionalData.tags"
                    value={
                      additionalData?.tags ? additionalData.tags.join(",") : ""
                    }
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Summary</label>
                  <Input
                    label="Summary"
                    type="textarea"
                    placeholder="Summary"
                    name="summary"
                    value={mediaItem?.summary ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Description</label>
                  <Input
                    label="Description"
                    type="textarea"
                    placeholder="Description"
                    name="description"
                    value={mediaItem?.description ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Transcript</label>
                  <Input
                    label="Transcript"
                    type="textarea"
                    placeholder="Transcript"
                    name="transcript"
                    value={mediaItem?.fulltext ?? ""}
                    onChange={handleChange}
                    disabled={true}
                    style={{ height: "300px" }}
                  />
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!savingMedia ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={
                  savingMedia ||
                  JSON.stringify(mediaItem) === mediaItemRef.current
                }
                style={{
                  opacity:
                    JSON.stringify(mediaItem) === mediaItemRef.current
                      ? 0.5
                      : 1,
                }}
              >
                {savingMedia ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i>{" "}
                    Processing...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("edit-media-item", EditMediaModal);

const NewMediaModal = NiceModal.create(({ public_id, title = "Media" }) => {
  const [savingMedia, setSavingMedia] = useState(false);
  const [mediaItem, setMediaItem] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);
  const formRef = useRef(null);
  const mediaItemRef = useRef(null);
  const modal = useModal();

  useEffect(() => {
    getMediaItem(public_id).then((item) => {
      console.log("!!! MEDIA ITEM: ", item);
      mediaItemRef.current = JSON.stringify(item);
      if (item?.additional_data) {
        try {
          const d = JSON.parse(item.additional_data);
          setAdditionalData(d);
        } catch (e) {
          console.error("!!! ERROR PARSING JSON: ", e);
        }
      }
      setMediaItem(item);
    });
  }, [public_id]);

  const hide = (e) => {
    modal.remove();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.search("additionalData") > -1) {
      const newName = name.split(".").pop();
      console.log("!!! NAME: ", newName);
      if (newName === "tags") {
        const tags = value.split(",");
        setAdditionalData({ ...additionalData, [newName]: tags });
      } else {
        setAdditionalData({ ...additionalData, [newName]: value });
      }

      setMediaItem({
        ...mediaItem,
        additional_data: JSON.stringify(additionalData),
      });
    } else {
      setMediaItem({ ...mediaItem, [name]: value });
    }
    console.log("CHANGE: ", name, value);
  };

  const save = async (e) => {
    setSavingMedia(true);
    const response = await updateMediaItem(mediaItem);
    console.log("!!! SAVE RESPONSE: ", response);
    const updatedMediaItem = response.success ? response.media : null;
    modal.resolve(updatedMediaItem);
    Swal.fire({
      title: "Success",
      text: "Media item updated successfully",
      icon: "success",
      button: "OK",
      confirmButtonText: "OK",
    }).then((result) => {
      setSavingMedia(false);
      modal.remove();
    });
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">New Media</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form ref={formRef}>
                  <label>ID</label>
                  <Input
                    label="ID"
                    type="text"
                    placeholder="ID"
                    name="id"
                    value={mediaItem?.public_id ?? ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label>Name</label>
                  <Input
                    label="Name"
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={mediaItem?.name ?? ""}
                    onChange={handleChange}
                  />
                  <label>Short Title</label>
                  <Input
                    label="Short Title"
                    type="text"
                    placeholder="Short Title"
                    name="short_title"
                    value={mediaItem?.short_title ?? ""}
                    onChange={handleChange}
                  />
                  <label>Category</label>
                  <Input
                    label="Category"
                    type="text"
                    placeholder="Category"
                    name="additionalData.category"
                    value={additionalData?.category ?? ""}
                    onChange={handleChange}
                  />
                  <label>Tags</label>
                  <Input
                    label="Tags"
                    type="textarea"
                    placeholder="Tags"
                    name="additionalData.tags"
                    value={
                      additionalData?.tags ? additionalData.tags.join(",") : ""
                    }
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Summary</label>
                  <Input
                    label="Summary"
                    type="textarea"
                    placeholder="Summary"
                    name="summary"
                    value={mediaItem?.summary ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Description</label>
                  <Input
                    label="Description"
                    type="textarea"
                    placeholder="Description"
                    name="description"
                    value={mediaItem?.description ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Transcript</label>
                  <Input
                    label="Transcript"
                    type="textarea"
                    placeholder="Transcript"
                    name="transcript"
                    value={mediaItem?.fulltext ?? ""}
                    onChange={handleChange}
                    disabled={true}
                    style={{ height: "300px" }}
                  />
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!savingMedia ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={
                  savingMedia ||
                  JSON.stringify(mediaItem) === mediaItemRef.current
                }
                style={{
                  opacity:
                    JSON.stringify(mediaItem) === mediaItemRef.current
                      ? 0.5
                      : 1,
                }}
              >
                {savingMedia ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i>{" "}
                    Processing...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("new-media-item", NewMediaModal);

const MediaTable = ({ media = [] }) => {
  const { selectedClient } = useContext(AppContext);
  const tableRef = useRef(null);
  let tokenCount = 0;
  const [localMedia, setLocalMedia] = useState(media);
  const [deleting, setDeleting] = useState(false);

  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setAgents(
          await getAgents(selectedClient.public_id ?? selectedClient.id)
        );
        console.log(agents);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM AGENTS: ", selectedClient);
    if (selectedClient) {
      fetchAgents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  useEffect(() => {
    setLocalMedia(media);
  }, [media]);

  window.edit = (public_id) => {
    NiceModal.show("edit-media-item", {
      public_id: public_id,
    }).then((updatedItem) => {
      console.log("!!! UPDATED ITEM: ", updatedItem);
      const newLocalMedia = [...localMedia];
      newLocalMedia.forEach((item) => {
        if (item.public_id === updatedItem.public_id) {
          item.name = updatedItem.name;
          item.short_title = updatedItem.short_title;
          item.summary = updatedItem.summary;
          item.description = updatedItem.description;
          item.additional_data = updatedItem.additional_data;
          item.token_count = updatedItem.token_count;
        }
      });
      setLocalMedia(newLocalMedia);
    });
  };

  window.new_media = () => {
    const agent_id = agents.length > 0 ? agents[0].id : null;
    console.log("!!! AGENT ID: ", agent_id);
    NiceModal.show("add-media", {
      agent_id,
      onSaveMedia: (m) => {
        console.log("SAVE MEDIA: ", m);
        const newMedia = [...media];
        newMedia.push(m);
        //setMedia(newMedia);
      },
      onError: (message) => {
        /*toast.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
          life: 3000,
        });*/
      },
    }).then((updatedItem) => {
      console.log("!!! UPDATED ITEM: ", updatedItem);
      const newLocalMedia = [...localMedia];
      newLocalMedia.forEach((item) => {
        if (item.public_id === updatedItem.public_id) {
          item.name = updatedItem.name;
          item.short_title = updatedItem.short_title;
          item.summary = updatedItem.summary;
          item.description = updatedItem.description;
          item.additional_data = updatedItem.additional_data;
          item.token_count = updatedItem.token_count;
        }
      });
      setLocalMedia(newLocalMedia);
    });
  };

  window.delete = (public_id) => {
    console.log("!!! MEDIA DELETE: ", public_id);
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === public_id);

      if (row) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
          if (result.value) {
            setDeleting(true);
            const response = await deleteMediaItem(public_id);
            console.log("!!! DELETE RESPONSE: ", response);
            const newLocalMedia = [...localMedia].filter(
              (item) => item.public_id !== public_id
            );
            setLocalMedia(newLocalMedia);

            setDeleting(false);
            Swal.fire(
              "Deleted!",
              "The media item has been deleted.",
              "success"
            );
          }
        });
      }
    }
  };

  const tableData = localMedia.map((mediaItem) => {
    tokenCount += mediaItem.token_count;
    return [
      mediaItem.public_id,
      `<div style="font-weight: bold">${mediaItem.name}</div>`,
      `<div style="font-weight: bold">${mediaItem.short_title}</div>`,
      mediaItem.summary,
      mediaItem.token_count,
      new Date(mediaItem.updated_at),
      `<div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center;" onClick="window.open('${mediaItem.fullpath}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"><svg style="width: 20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/></svg></button><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${mediaItem.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${mediaItem.public_id}')" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Media ({tokenCount} tokens)
        <span
          style={{
            fontSize: "20px",
            fontWeight: "normal",
            marginLeft: "10px",
            cursor: "pointer",
          }}
          onClick={() => {
            window.new_media("");
          }}
        >
          <i className="fas fa-plus"></i>
        </span>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[5, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th style={{ minWidth: "200px" }}>Name</th>
            <th style={{ minWidth: "100px" }}>Short Title</th>
            <th style={{ minWidth: "400px" }}>Summary</th>
            <th>Tokens</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
      {deleting ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #ccc",
          }}
        >
          <i
            className="fas fa-circle-notch fa-spin"
            style={{ fontSize: "50px", textAlign: "center" }}
          ></i>
          <div style={{ fontSize: "20px", fontWeight: "bold" }}>
            Deleting...
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MediaTable;
